import { Routes } from '@angular/router';
import { IngestFilesComponent } from './feature-vault/src/lib/ingest/ingest-files/ingest-files.component';
import { IngestProjectDetailComponent } from './feature-vault/src/lib/ingest/ingest-project-detail/ingest-project-detail.component';
import { IngestProjectsComponent } from './feature-vault/src/lib/ingest/ingest-projects/ingest-projects.component';
import { IngestUploadHubComponent } from './feature-vault/src/lib/ingest/ingest-upload-hub/ingest-upload-hub.component';
import { IngestUploadComponent } from './feature-vault/src/lib/ingest/ingest-upload/ingest-upload.component';
import { PreservationTraceComponent } from './feature-vault/src/lib/ingest/preservation-trace/preservation-trace.component';
import { PreservationTraceDashboardComponent } from './feature-vault/src/lib/ingest/preservation-trace-dashboard/preservation-trace-dashboard.component';

/**
 * Rutas bajo `/vault` (A5.4):
 * - `projects` — CRUD / tabla
 * - `projects/:id` — detalle
 * - `upload` — selector → carga por proyecto
 * - `files` / `files/:projectId` — explorador
 * - `projects/:id/upload` — carga contextual
 */
export const INGEST_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'projects',
  },
  {
    path: 'projects',
    component: IngestProjectsComponent,
    title: 'Expedientes de Ingesta',
    data: { breadcrumb: 'Expedientes' },
  },
  {
    path: 'upload',
    component: IngestUploadHubComponent,
    title: 'Cargar documentos',
    data: { breadcrumb: 'Cargar' },
  },
  {
    path: 'files',
    component: IngestFilesComponent,
    title: 'Explorador de archivos',
    data: { breadcrumb: 'Archivos' },
  },
  {
    path: 'files/:projectId',
    component: IngestFilesComponent,
    title: 'Explorador de archivos',
    data: { breadcrumb: 'Archivos' },
  },
  {
    path: 'projects/:id/upload',
    component: IngestUploadComponent,
    title: 'Carga de archivos',
    data: { breadcrumb: 'Cargar' },
    canDeactivate: [
      (component: IngestUploadComponent) => component.canDeactivateUpload(),
    ],
  },
  {
    path: 'projects/:id',
    component: IngestProjectDetailComponent,
    title: 'Detalle de expediente',
    data: { breadcrumb: 'Detalle' },
  },
  {
    path: 'recorrido/:ingestId',
    component: PreservationTraceComponent,
    title: 'Recorrido del archivo',
    data: { breadcrumb: 'Recorrido' },
  },
  {
    path: 'trazabilidad',
    component: PreservationTraceDashboardComponent,
    title: 'Trazabilidad de Preservación',
    data: { breadcrumb: 'Trazabilidad' },
  },
];
